var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28.5C12.3455 28.5 10.932 27.9422 9.75964 26.8266C8.58655 25.7109 8 24.3474 8 22.7359C8 21.3547 8.42727 20.124 9.28182 19.0438C10.1364 17.9635 11.2545 17.2729 12.6364 16.9719C13.0909 15.3427 14 14.0234 15.3636 13.0141C16.7273 12.0047 18.2727 11.5 20 11.5C22.1273 11.5 23.9316 12.2214 25.4131 13.6643C26.8953 15.1079 27.6364 16.8656 27.6364 18.9375C28.8909 19.0792 29.932 19.6058 30.7596 20.5174C31.5865 21.4298 32 22.4969 32 23.7188C32 25.0469 31.5229 26.176 30.5687 27.106C29.6138 28.0353 28.4545 28.5 27.0909 28.5H21.0909V20.9031L22.0727 21.8328C22.2727 22.0276 22.5229 22.125 22.8233 22.125C23.1229 22.125 23.3818 22.0188 23.6 21.8062C23.8 21.6115 23.9 21.3635 23.9 21.0625C23.9 20.7615 23.8 20.5135 23.6 20.3188L20.7636 17.5562C20.5455 17.3438 20.2909 17.2375 20 17.2375C19.7091 17.2375 19.4545 17.3438 19.2364 17.5562L16.4 20.3188C16.2 20.5135 16.0956 20.7569 16.0869 21.0487C16.0775 21.3412 16.1818 21.5938 16.4 21.8062C16.6 22.001 16.8498 22.103 17.1495 22.1123C17.4498 22.1207 17.7091 22.0276 17.9273 21.8328L18.9091 20.9031V28.5H14Z",
    fill: "#8494AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.db78d0cd5550bb55d45b65fa9d402545.svg";
export { ForwardRef as ReactComponent };